/* eslint-disable */
import {ScrollView, StyleSheet, Text, View} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useTranslation} from 'react-i18next';
import OnboardingButton from '../../components/onboarding/OnboardingButton';
import StepHeader from '../../components/onboarding/StepHeader';
import SelectCard from '../../components/onboarding/SelectCard';
import {colors, radii, spacing, typography} from '../../config/theme';
import {FREQUENCY_ICONS} from '../../config/onboardingData';
import AppIcon from '../../components/onboarding/AppIcon';
import {useOnboarding} from './OnboardingContext';

const RefuelFrequency = ({navigation}) => {
  const {t} = useTranslation();
  const {
    config,
    update,
    currency: CURRENCY,
    selectedFrequency: selected,
  } = useOnboarding();
  const options = config.fuelFrequency.options;

  return (
    <SafeAreaView style={styles.safe}>
      <StepHeader
        title={t('onboarding.commuteHabits', 'Commute Habits')}
        step={2}
        total={config.totalSteps}
        onBack={() => navigation.goBack()}
      />

      <ScrollView
        contentContainerStyle={styles.scroll}
        showsVerticalScrollIndicator={false}>
        <Text style={styles.title}>
          {t('onboarding.refuel.title', 'HOW OFTEN DO YOU')}
          {'\n'}
          <Text style={styles.titleAccent}>
            {t('onboarding.refuel.titleAccent', 'REFUEL?')}
          </Text>
        </Text>
        <Text style={styles.subtitle}>
          {t(
            'onboarding.refuel.subtitle',
            'Pick your habit to calculate savings.',
          )}
        </Text>

        <View style={styles.list}>
          {options.map(o => {
            const isSelected = o.id === selected.id;
            return (
              <SelectCard
                key={o.id}
                selected={isSelected}
                onPress={() => update({frequency: o.id})}>
                <View style={styles.row}>
                  <View
                    style={[styles.iconWrap, isSelected && styles.iconWrapOn]}>
                    <AppIcon name={FREQUENCY_ICONS[o.id] || 'car'} size={24} />
                  </View>

                  <View style={styles.rowText}>
                    <View style={[styles.tag, o.highlighted && styles.tagPopular]}>
                      <Text
                        style={[
                          styles.tagText,
                          o.highlighted && styles.tagTextPopular,
                        ]}>
                        {o.highlighted ? '★ ' : ''}
                        {o.tag}
                      </Text>
                    </View>
                    <Text style={styles.label}>{o.label}</Text>
                    <Text style={styles.saving}>
                      +{CURRENCY}
                      {o.yearlySavings} / {t('onboarding.yearSaved', 'year saved')}
                    </Text>
                  </View>
                </View>
              </SelectCard>
            );
          })}
        </View>

        {/* Smart forecast */}
        <View style={styles.forecast}>
          <View style={styles.forecastIcon}>
            <AppIcon name="bulb" size={24} />
          </View>
          <View style={styles.forecastText}>
            <Text style={styles.forecastLabel}>
              {t('onboarding.refuel.forecast', 'SMART FORECAST')}
            </Text>
            <Text style={styles.forecastBody}>
              {t('onboarding.refuel.estimated', 'Estimated annual savings:')}{' '}
              <Text style={styles.forecastValue}>
                {CURRENCY}
                {selected.forecast.max}
              </Text>
            </Text>
          </View>
        </View>
      </ScrollView>

      <View style={styles.footer}>
        <OnboardingButton
          title={t('onboarding.next', 'NEXT STEP →')}
          onPress={() => navigation.navigate('SavingsRadar')}
        />
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safe: {flex: 1, backgroundColor: colors.background},
  scroll: {
    paddingHorizontal: spacing.margin,
    paddingTop: spacing.lg,
    paddingBottom: spacing.lg,
    gap: spacing.md,
  },
  title: {...typography.displayMobile, color: colors.primary},
  titleAccent: {color: colors.secondary},
  subtitle: {...typography.bodyMd, color: colors.textMuted},

  list: {gap: spacing.md, marginTop: spacing.sm},
  row: {flexDirection: 'row', alignItems: 'center', gap: spacing.md},
  iconWrap: {
    width: 48,
    height: 48,
    borderRadius: radii.pill,
    backgroundColor: colors.mintSoft,
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconWrapOn: {backgroundColor: colors.tertiary},
  icon: {fontSize: 22},
  rowText: {flex: 1, gap: spacing.xs, paddingRight: 36},

  tag: {
    alignSelf: 'flex-start',
    backgroundColor: colors.surfaceMuted,
    borderRadius: radii.pill,
    paddingHorizontal: spacing.sm,
    paddingVertical: 2,
  },
  tagPopular: {backgroundColor: colors.primaryFixed},
  tagText: {...typography.labelSm, color: colors.textMuted},
  tagTextPopular: {color: colors.primary},
  label: {...typography.headlineSm, color: colors.text},
  saving: {...typography.labelMd, color: colors.secondary},

  forecast: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.md,
    backgroundColor: colors.mintSoft,
    borderRadius: radii.card,
    padding: spacing.md + 4,
    marginTop: spacing.xs,
  },
  forecastIcon: {
    width: 48,
    height: 48,
    borderRadius: radii.pill,
    backgroundColor: colors.tertiary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  forecastText: {flex: 1, gap: 2},
  forecastLabel: {...typography.labelSm, color: colors.primary},
  forecastBody: {...typography.bodyMd, color: colors.text},
  forecastValue: {...typography.headlineSm, color: colors.primary},

  footer: {
    paddingHorizontal: spacing.margin,
    paddingTop: spacing.sm,
    paddingBottom: spacing.lg,
    backgroundColor: colors.background,
  },
});

export default RefuelFrequency;